import script from "./ViaggioTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./ViaggioTimeline.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__